import { MpxSearch, GeometryApi, MpxSearchQuery } from '@cibo/core'

const RANGE_X = 20
const RANGE_Y = 10

const generateTestRect = () => {
  const dX = Math.random() * RANGE_X - RANGE_X / 2
  const dY = Math.random() * RANGE_Y - RANGE_Y / 2
  return {
    lowerLeft: { Longitude: -95.94 + dX, Latitude: 40.0 + dY },
    upperRight: { Longitude: -95.92 + dX, Latitude: 40.3 + dY },
  }
}

export const randomTillableParcel = async (query?: MpxSearchQuery) => {
  let i = 0

  do {
    const results = await MpxSearch.query({
      ...(query || generateTestRect()),
      tillablePercentGe: 50,
    })
    if (!results?.parcelResults?.length) {
      continue
    }

    const parcelResult = results.parcelResults[0]

    if (parcelResult?.properties?.tillableGeometrySlug) {
      return parcelResult
    }

    ++i
  } while (i < 10) // try only ten times to find tillable parcels
}

export const randomTillableParcelGeometry = async (query?: MpxSearchQuery) => {
  const parcel = await randomTillableParcel(query)

  if (parcel?.properties.tillableGeometrySlug) {
    return GeometryApi.getGeometry(parcel?.properties.tillableGeometrySlug)
  }
}
